"use client"

import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"
import {useTheme} from "@/context/ThemeContext";

export function Toaster() {
  const { toasts } = useToast()
  const { theme } = useTheme();

  return (
    <ToastProvider>
      <style jsx global>{`
          :root {
            --primary-color: ${theme.colors.primary};
            --secondary-color: ${theme.colors.secondary};
            --accent-color: ${theme.colors.accent};
            /* Add more CSS variables as needed */
          }
        `}</style>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport className="fixed top-4 right-4 z-[100] flex flex-col max-h-screen w-full md:max-w-[420px]" />
    </ToastProvider>
  )
}
